import React from 'react'
import { Button } from './button-v2'
import { cn } from '~shared/utils/cn'
import { Shevron } from '~shared/icons/shevron'
import { useClickOutside } from '~shared/utils/useClickOutSide'

type TSearchParams = {
  duration: { slug: string; name: string }
  faculty: { slug: string; name: string }
  category: { slug: string; name: string }
  format: { slug: string; name: string }
}

interface Props {
  selectData: {
    filterName: {
      name: string | null
      slug: string | null
    }
    list: {
      slug: string | null
      name: string | null
    }[]
  }
  isShort?: boolean
  searchParams: TSearchParams
  setSearchParams: React.Dispatch<React.SetStateAction<TSearchParams>>
  setShowedPrograms?: React.Dispatch<React.SetStateAction<number>>
}

export const Select: React.FC<Props> = ({
  selectData,
  searchParams,
  setSearchParams,
  setShowedPrograms,
  isShort
}) => {
  // const [selectedItem, setSelectedItem] = React.useState(selectData.filterName)
  const [openMenu, setOpenMenu] = React.useState(false)
  const containerRef = React.useRef<HTMLDivElement>(null)

  useClickOutside(containerRef, () => setOpenMenu(false))

  const handleItemSelect = (item: {
    slug: string | null
    name: string | null
  }) => {
    const updatedKey = selectData.filterName.slug
    setSearchParams((prev: TSearchParams) => ({
      ...prev,
      [updatedKey!]: item
    }))
    // setSelectedItem(item ?? '')
    if (setShowedPrograms) setShowedPrograms(6)
    setOpenMenu(false)
  }

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLLIElement>,
    item: { slug: string | null; name: string | null }
  ) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleItemSelect(item)
    }
  }

  return (
    <div
      className={cn('relative w-full', openMenu ? 'z-50' : 'z-10')}
      ref={containerRef}>
      {openMenu && (
        <div
          className={cn(
            `absolute rounded-[24px]  pb-[24px] shadow-xl top-0 left-0 w-full bg-white pr-[5px] text-[14px] lowercase`
          )}>
          <ul
            className={cn(
              'flex flex-col gap-[24px] mt-[90px] max-h-[300px] overflow-y-auto scrollbar-always'
            )}>
            {selectData?.list.map(item => (
              <li
                key={item.slug}
                onClick={() => handleItemSelect(item)}
                onKeyDown={e => handleKeyDown(e, item)}
                tabIndex={0}
                role='option'
                // aria-selected={item.slug === selectedItem.slug}
                aria-selected={
                  item.slug ===
                  searchParams[
                    selectData.filterName.slug as keyof TSearchParams
                  ]?.slug
                }
                className='cursor-pointer text-accent px-[16px] xl:px-[24px] xl:pr-[15px] hover:underline'>
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      )}
      <Button
        size='slg'
        variant='none'
        className={cn(
          ` w-full  px-[16px] xl:px-[24px] flex  text-[14px]`,
          isShort ? 'justify-center' : 'justify-between',
          searchParams[selectData.filterName.slug as keyof TSearchParams]
            .slug === selectData.filterName.slug ||
            searchParams[selectData.filterName.slug as keyof TSearchParams]
              .slug === 'all'
            ? 'bg-secondary text-tertiary'
            : 'bg-accent text-primary'
        )}
        onClick={() => setOpenMenu(!openMenu)}
        aria-expanded={openMenu}
        aria-haspopup='listbox'>
        {!isShort && (
          <span className='inline-block max-w-[180px] text-wrap text-left break-words lowercase'>
            {searchParams[selectData.filterName.slug as keyof TSearchParams]
              .slug === 'all'
              ? selectData.filterName.name
              : searchParams[selectData.filterName.slug as keyof TSearchParams]
                  .name}
          </span>
        )}
        <span className='mr-[6px] md:mr-0'>
          <Shevron
            size='lg'
            className={cn(
              'duration-200',
              openMenu ? '-rotate-90' : 'rotate-90'
            )}
          />
        </span>
      </Button>
    </div>
  )
}
